import { IForm } from '@/components/types'

export const searchFormConfig: IForm = {
  labelWidth: '150px',
  formItems: [
    {
      field: 'parentDeptId',
      type: 'select',
      label: '组',
      clearable: true,
      placeholder: '请选择组',
      filterable: true,
      options: []
    },
    {
      field: 'deptName',
      type: 'select',
      label: '岗位',
      clearable: true,
      placeholder: '请选择岗位',
      filterable: true,
      options: [
        { title: '全部', value: '' },
        { title: '518', value: '518' },
        { title: '投教', value: '投教' }
      ]
    },
    {
      field: 'dateStart',
      type: 'datepicker',
      label: '筛选日期',
      otherOptions: {
        placeholder: '选择筛选日期',
        type: 'date',
        'value-format': 'YYYY-MM-DD'
      }
    },
    {
      field: 'bonusOk',
      type: 'switch',
      activeValue: 1,
      inActiveValue: 0,
      label: '符合要求名单'
    }
  ]
}
